import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

export interface ConfigureClockifyIntegrationRequest {
  apiKey: string;
}

/**
 * Configure Clockify integration with API token
 */
export const configureClockifyIntegration = async (
  data: ConfigureClockifyIntegrationRequest
): Promise<void> => {
  const endpoint = '/api/integrations/clockify/configure';

  await withApiErrorHandler(endpoint, ApiErrorCode.INTEGRATION_CLOCKIFY_CONFIGURE_FAILED, () =>
    axiosInstance.post(endpoint, data)
  );
};
